/**
 * What of a spec may leave the building (#70).
 *
 * The recipe book is the bar's own work, and its costing is the part a
 * competitor would most like to see. So a drink shared publicly — a post, a
 * caption — is a deliberate projection of the spec rather than the spec with
 * some fields hidden on screen: name, style and the serve, and the
 * ingredients by name with **no quantities, no costs, no prices and no
 * suppliers**. Anything added to `Spec` later stays private until somebody
 * decides to add it here, which is the safe direction for a default to fall.
 *
 * Sharing inside the team needs none of this: a link to the spec opens it for
 * anyone signed in to the organisation, with everything their role may see.
 */
export function publicRecipe(spec, ingredients) {
    const names = [];
    for (const line of spec.lines) {
        const ingredient = ingredients.get(line.ingredientId);
        // Dilution is how the drink is made, not what is in it.
        if (ingredient?.kind === "dilution")
            continue;
        const name = ingredient?.name ?? line.ingredientId;
        if (!names.includes(name))
            names.push(name);
    }
    return {
        name: spec.name,
        style: spec.style.filter((s) => s.trim()),
        glass: spec.glass.trim(),
        method: spec.method.trim(),
        ice: spec.ice.trim(),
        garnish: spec.garnish.trim(),
        ingredients: names,
    };
}
/** The projection as a caption a person can paste and edit. */
export function publicRecipeText(recipe, from) {
    const serve = [recipe.method, recipe.glass, recipe.ice && `over ${recipe.ice.toLowerCase()}`]
        .filter(Boolean)
        .join(" · ");
    return [
        recipe.name,
        recipe.style.join(" · "),
        recipe.ingredients.join(", "),
        serve,
        recipe.garnish && `Garnish: ${recipe.garnish}`,
        from ? `— ${from}` : "",
    ]
        .filter((line) => line && line.trim())
        .join("\n");
}
//# sourceMappingURL=share.js.map